import { useEffect, useContext, useState } from 'react';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { getCompanyPagePermissionStatus } from '@bingads-webui-campaign-react/linkedin-data';

import { COMPANY_PAGE_LINKING_ACTIONS } from '../reducer';

export const useLoadPermissionStatus = (state, dispatch, logger) => {
  const { scope } = useContext(ScopeContext);
  const { cid, aid } = scope.values;
  const [isProcessing, setIsProcessing] = useState(false);

  const { isLoadingPermissionStatus, authorizationData } = state;

  useEffect(() => {
    if (isLoadingPermissionStatus && !isProcessing) {
      setIsProcessing(true);
      getCompanyPagePermissionStatus(cid, aid).then((res) => {
        logger.trace(`Permission status loaded: ${JSON.stringify(res)}`);
        dispatch({
          type: COMPANY_PAGE_LINKING_ACTIONS.PERMISSION_STATUS_LOADED,
          permissionStatus: res.value,
        });
      }).catch((err) => {
        logger.trace(`Failed to load permission status: ${JSON.stringify(err)}`);
        dispatch({ type: COMPANY_PAGE_LINKING_ACTIONS.PERMISSION_STATUS_LOAD_FAILED, loadPermissionStatusError: err });
      }).finally(() => {
        setIsProcessing(false);
      });
    }
  }, [aid, authorizationData, cid, dispatch, isLoadingPermissionStatus, isProcessing, logger]);
};

